import React from 'react';

import {CallSchema} from '../wfReactInterface/wfDataModelHooksInterface';
import {ExceptionAlert} from './Exceptions';

export const CallErrorMessage: React.FC<{
  call: CallSchema;
}> = ({call}) => {
  if (!call.rawSpan.exception) {
    return null;
  }

  return <ExceptionAlert exception={call.rawSpan.exception} />;
};
